import styles from './ButtonCheckbox.module.css'
import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'

interface ButtonCheckboxProps extends BasicStyledComponent {
  active: boolean
  onClick: () => void
}

const ButtonCheckbox: React.FC<ButtonCheckboxProps & React.PropsWithChildren> = ({
  onClick,
  active,
  className,
  children,
}) => (
  <button
    onClick={onClick}
    type="button"
    className={clsx(styles.container, className, {
      [styles.active]: active,
      [styles.notActive]: !active,
    })}
  >
    {children}
  </button>
)

export default ButtonCheckbox
